<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      Account <span class="fa fa-chevron-down"></span>
    </template>
    <template slot="dropdown">
      <b-dropdown-header
        tag="div"
        class="text-center">
        <strong>Settings</strong>
      </b-dropdown-header>
      <b-dropdown-item to="/settings"><i class="fa fa-wrench" /> Settings</b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item v-on:click="logout()"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  methods: {
    logout: function () {
      this.$store.dispatch('AUTH_LOGOUT')
        .then(() => {
          this.$router.push('/login')
        })
    }
  }
}
</script>
